import React, { useEffect, useState } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { useParams,useNavigate } from "react-router-dom";
import { showToast } from "../ShowToast/ToastNotification";
import { Button } from "react-bootstrap";

const AllUsersBreachResultsCheckId = () => {
  const { t } = useTranslation();

  const { checkId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [breachData, setBreachData] = useState(null);

  const fetchAllUsersBreachResultsCheckId = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/breach-check/result/${checkId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (!response.ok) {
        showToast(
          result?.message?.en || t("somethingWentWrongRefresh"),
          "error"
        );
        return;
      }

      setBreachData(result.data);
    } catch (error) {
      console.log(error);
      showToast(t("somethingWentWrongRefresh"), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (checkId) {
      fetchAllUsersBreachResultsCheckId();
    }
  }, [checkId]);

  return (
    <div
      className="py-4"
      style={{
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        padding: "15px",
      }}
    >
    
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div className="pageTitle">{t("Breach Result Details")}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>
          {t("Back")}
        </Button>
      </div>
      {loading ? (
        <div>Loading...</div>
      ) : breachData ? (
        <table className="table table-bordered">
          <tbody>
            {/* <tr>
              <th>Check ID</th>
              <td>{breachData.check_id}</td>
            </tr> */}

            {/* <tr>
              <th>User ID</th>
              <td>{breachData.user_id}</td>
            </tr> */}

            <tr>
              <th>Username</th>
              <td>{breachData.user?.username}</td>
            </tr>

            <tr>
              <th>First Name</th>
              <td>{breachData.user?.firstname}</td>
            </tr>

            <tr>
              <th>Last Name</th>
              <td>{breachData.user?.lastname}</td>
            </tr>

            <tr>
              <th>Email</th>
              <td>{breachData.email}</td>
            </tr>

            <tr>
              <th>Status</th>
              <td>{breachData.status}</td>
            </tr>

            <tr>
              <th>Compromised</th>
              <td>
                {breachData.compromised ? "Yes" : "No"}
              </td>
            </tr>

            <tr>
              <th>Breaches</th>
              <td>
                {Array.isArray(breachData.breaches) &&
                breachData.breaches.length > 0
                  ? breachData.breaches.join(", ")
                  : "-"}
              </td>
            </tr>

            {/* <tr>
              <th>HTTP Status</th>
              <td>{breachData.http_status || "-"}</td>
            </tr> */}

            <tr>
              <th>Error Message</th>
              <td>{breachData.error_message || "-"}</td>
            </tr>

            {/* <tr>
              <th>Checked At</th>
              <td>{breachData.checked_at}</td>
            </tr> */}

            {/* <tr>
              <th>Created At</th>
              <td>{breachData.created_at}</td>
            </tr> */}
          </tbody>
        </table>
      ) : (
        <div>No Data Found</div>
      )}
    </div>
  );
};

export default AllUsersBreachResultsCheckId;